__turbopack_context__.v({
  "hint": "PanelOptionTiles-module-scss-module__Q161Ua__hint",
  "icon": "PanelOptionTiles-module-scss-module__Q161Ua__icon",
  "selected": "PanelOptionTiles-module-scss-module__Q161Ua__selected",
  "text": "PanelOptionTiles-module-scss-module__Q161Ua__text",
  "tile": "PanelOptionTiles-module-scss-module__Q161Ua__tile",
  "tiles": "PanelOptionTiles-module-scss-module__Q161Ua__tiles",
});
